/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/09/22 10:14
 * @update 2026/09/22 10:14
 */

import { Col, Modal, Row, ModalHeader, ModalBody, Dropdown, ModalFooter, Button } from 'diginet-core-ui/components';
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as W14F1020Actions from "../../../actions/w14/w14F1020/w14F1020-actions";
import Config from "../../../config";
import { Loading } from "../../common/loading/loadingCore";

const initialDataMaster = {
    StatusID: '',
    StatusName: '',
};

const W14F1020UpdateStatus = (props) => {
    const { open, onClose, dataUpdateStatus, loading, dataFilter, dataCheck } = props;
    const [dataMaster, setDataMaster] = useState({ ...initialDataMaster });
    const [formLoading, setFormLoading] = useState(false);
    const [isChanged, setIsChanged] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const dataTransID = dataCheck?.map(item => ({TransID: item?.TransID}));

    const getParamGeneral = (DataTypeID = '', dataRow = {}) => {
        const { IsDate, IsPeriod, SalesPersonID = "", GroupSalesID = "", DateFrom = null,  DateTo= null, ObjectID = "", PeriodFrom = "", PeriodTo = ""} = dataFilter || {};
        let objResult = {
            FormID: 'W14F1020',
            DataTypeID,
            DateFrom,
            DateTo,
            GroupSalesID,
            SalesPersonID,
            IsDate,
            IsPeriod,
            IsPaymentChannels: null,
            StatusID: dataMaster?.StatusID || '',
            TransID: "",
            CommissionID: '',
            PeriodFrom,
            PeriodTo,
            ObjectID,
            data: dataTransID || [],
        };
        return objResult
    };

    const onSave = async () => {
        setFormLoading(true);
        props.W14F1020Actions.updateStatus(getParamGeneral("Uploadpayment", dataMaster), (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    setIsChanged(true);
                    Config.notify.show('success', Config.lang('Luu_thanh_cong'), 2000);
                    onClose(true);
                } else if (data?.Message) Config.popupCore.show('WARNING', data.Message);
            }
        });
    };

    const handleChangeStatus = (e) => {
        const value = e?.value ?? e?.target?.value ?? '';
        setIsChanged(true);
        setDataMaster({ ...dataMaster, StatusID: value || "", StatusName: e?.data?.StatusName || "" })
    }

    return (
        <>
            <Modal
                open={open}
                size={'md'}
                onClose={onClose} >
                <ModalHeader>{Config.lang("Cap_nhat_trang_thai")}</ModalHeader>
                <ModalBody>
                    <Loading visible={formLoading} />
                    <Row>
                        <Col xs={12} sm={12}>
                            <Dropdown
                                clearAble
                                viewType={'outlined'}
                                valueExpr={'StatusID'}
                                displayExpr={'StatusName'}
                                loading={loading}
                                label={Config.lang('Trang_thai')}
                                dataSource={dataUpdateStatus}
                                onChange={handleChangeStatus}
                                value={dataMaster?.StatusID}
                                labelProps={{ type: 'h4' }}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div className={'jus-end'}>
                        <Button
                            viewType={'filled'}
                            color={'info'}
                            startIcon={'Save'}
                            disabled={!isChanged}
                            label={Config.lang('Luu')}
                            onClick={onSave}
                        />
                    </div>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default connect(null, (dispatch) => ({
    W14F1020Actions: bindActionCreators(W14F1020Actions, dispatch),
}))(W14F1020UpdateStatus);